import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

// Filter keys are written by the shared FilterDrawer.
const manualTransferSearchSchema = z.object({
  page: z.union([z.string(), z.number()]).optional(),
  limit: z.union([z.string(), z.number()]).optional(),
  tab: z.string().optional(),
  card: z.string().optional(),
  receivingBankCode: z.string().optional(),
  sortBy: z.string().optional(),
  sortDir: z.string().optional(),
  search: z.coerce.string().optional(),
  checker_email: z.string().optional(),
  manual_transfer_status: z.string().optional(),
  proposed_decision: z.string().optional(),
  refund_status: z.string().optional(),
  min_amount: z.coerce.string().optional(),
  max_amount: z.coerce.string().optional(),
  start_at: z.string().optional(),
  end_at: z.string().optional(),
});

export const manualTransferRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/manual-transfer',
  validateSearch: manualTransferSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/manual-transfer/manual-transfer-page')),
});

export const detailManualTransferRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/manual-transfer/$id',
  component: lazyRouteComponent(() => import('@/pages/manual-transfer/detail')),
});
